import user_agent_parser from 'user-agent-parser'

var user_agent = navigator ? navigator.userAgent : ''
var ua_parser = user_agent_parser(user_agent)

function getUA() {
	return ua_parser
}

function isIphone() {
	return ua_parser.device && ua_parser.device.model === 'iPhone'
}

function isIpad() {
	return ua_parser.device && ua_parser.device.model === 'iPad'
}

function isChrome() {
	return ua_parser.browser.name === 'Chrome'
}

function isIos() {
	return ua_parser.os.name === 'iOS'
}

function isIE() {
	return ua_parser.browser.name === 'IE'
}

function isChromebook() {
	return (ua_parser.os && ua_parser.os.name.includes('Chromium'))
}

export default getUA

export {
	isIphone,
	isIpad,
	isChrome,
	isIos,
	isIE,
	isChromebook,
}
